import clearErrorsLocation from 'pages/Customers/CustomersLocations/ClearErrorsLocation/actionCreators';

const clearErrorsLocationAction = () => async (dispatch) => {
  dispatch(clearErrorsLocation(''));
};

export default clearErrorsLocationAction;
